<template>
	<div class="login-box">
		<div class="login-avatar">
			<i @click.stop="back" class="icon icon-back"></i>
			<div>
				<div class="icon icon-avatar"></div>
				<p>+{{region}} {{phone}}</p>
			</div>
		</div>
		<p>请输入验证码</p>
		<baseinput
				:error="tip"
				:min="0"
				:max="6"
				type="tel"
				placeholder="请输入验证码"
				v-model.trim="code"
				v-on:input="onInput"
				v-on:keyup.enter="setSign"
			>
				<div class="g-Btn" :class="cssname" @click.stop="getAuthcode" slot="after">
					{{text}}
				</div>
			</baseinput>
		<div class="g-Btn g-Btn-green2" @click="setSign">{{loginText || '登录'}}</div>
		<baseradio
			v-show="!isReg"
			ref="agree"
			:on="false">
				<p>我同意<a @click.stop="goRemember" href="https://ps.res.netease.com/cloudgame/agreement.html" target="_blank">《用户协议》</a>及<a @click.stop="goRemember" href="https://reg.163.com/agreement_mobile_ysbh_wap.shtml?v=20171127" target="_blank">《隐私政策》</a></p>
		</baseradio>
	</div>
</template>

<script>
import baseinput from '@/components/input/input'
import baseradio from '@/components/input/radio'
import api from '@/api'
export default {
  name: 'logincode',
  props: {
    phone: String,
    region: [String, Number],
    isReg: Boolean,
    mobile: Boolean,
    loginText: String,
    validate: String
  },
  data () {
    return {
      timeThreshold: 60,
      issend: false,
      code: '',
      tip: '',
      time: '',
      timer: null,
      captcha: '',
      canLogin: true
    }
  },
  created () {
  },
  components: {
    baseinput,
    baseradio
  },
  computed: {
    text () {
      return this.issend ? this.time + 'S后重发' : '获取验证码'
    },
    cssname () {
      return this.issend ? 'g-Btn-wz' : 'g-Btn-green'
    }
  },
  watch: {
    phone (n, o) {
      this.canLogin = true
      // 重置
      if (n !== o) {
        this.issend = false
        clearInterval(this.timer)
      }
    },
    region (n, o) {
      this.canLogin = true
      // 重置
      if (n !== o) {
        this.issend = false
        clearInterval(this.timer)
      }
    }
  },
  methods: {
    goRemember () {
      if (this.mobile) {
        this.$storage.set('NCG-phone', this.phone)
        this.$storage.set('NCG-back', true)
      }
      return false
    },
    reset () {
      this.code = ''
      clearInterval(this.timer)
      this.issend = false
      this.time = ''
      this.captcha = ''
      this.canLogin = true
    },
    onInput () {
      this.tip = ''
    },
    back () {
      this.tip = ''
      this.$emit('back')
    },
    setSign () {
      this.$store.dispatch('postBehaviors', {
            action: 'page_login_enter'
      })
      const top = this.$parent.getTop()
      if (!this.code.length) {
        this.tip = '请输入验证码'
        return false
      }
      if (!this.isReg && !this.$refs.agree.checked) {
        this.$toast({
          top: top,
          type: 'fail',
          text: '请先同意用户协议和隐私政策'
        })
        return false
      }
      // 404， 不可操作的
      if (!this.canLogin) {
        this.$toast({
          top: top,
          type: 'warn',
          text: '抱歉，您目前尚未获得测试资格'
        })
        return false
      }
      this.$emit('setSign', {
        code: this.code,
        captcha: this.captcha
      })
    },
    getAuthcode () {
      if (this.issend) {
        return false
      }
      console.log('去发送验证码', this.phone)
      this.time = this.timeThreshold - 1
      this.issend = true
      this.interval()
      this.$http.post(api.getCaptcha(this.region, this.phone), {
        etc: {
          validate: this.validate
        }
      }).then((res) => {
        this.captcha = res.captcha
        this.code = this.captcha
        this.canLogin = true
      }, (err) => {
        // const status = err.status
        const top = this.$parent.getTop()
        const code = err.data || {}
        console.log('获取验证码错', err)
        // const type = (code.errcode === 1105 || code.errcode === 1100) ? 'warn' : 'fail'
        // if (status === 403) {
          // clearInterval(this.timer)
          // this.issend = false
          // 无测试资格，不让登录
          // if (code.errcode === 1105) {
          //   this.canLogin = false
          //   this.$toast({
          //     top: top,
          //     type: 'warn',
          //     text: '抱歉，您目前尚未获得测试资格'
          //   })
          //   return false
          // }
          // 发送频繁不提醒了
          if (code.errcode === 1100) {
            // code.errcode === 1100 ? '您获取验证码过于频繁，请于1分钟后重试' :
            return false
          }
          // // 号码不能过
          // if (code.errcode === 1101) {
          //   this.canLogin = false
          //   this.$toast({
          //     top: top,
          //     type: 'warn',
          //     text: '抱歉目前暂不支持虚拟运营商号段注册及登录'
          //   })
          //   return false
          // }
          // 无资格或者非法号段
          if (code.errcode === 1105 || code.errcode === 1101){
            this.canLogin = false
          }
          //其它错误
          this.$toast({
            top: top,
            type: 'fail',
            text: code.errmsgcn || '获取验证码异常，请稍后重试'
          })

        // }
      })
    },
    interval () {
      clearInterval(this.timer)
      this.timer = window.setInterval(() => {
        this.time--
        if (this.time <= 0 ) {
          clearInterval(this.timer)
          this.issend = false
        }
      }, 1000)
    }
  },
  mounted () {
  }
}
</script>
